export default "__VITE_ASSET__BDmA9m99__"